import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { User, userApi } from '../../api/user';
import { useAuth } from 'providers';

export const useGetUser = (): UseQueryResult<User | null> => {
  const { isSignedIn, isLoaded } = useAuth();
  const enabled = isSignedIn && isLoaded;

  return useQuery(['get-user'], userApi.getUser, { enabled, refetchOnWindowFocus: false });
};
